var PinZones = function(gallery, jsonData, viewOptions) {
    var _this = this,
        highlightPin = true,
        itemSettings = {
            w: 25,
            h: 25
        };

    _this.$pageZones;

    function _getImgSizeKey(forceLargeImg) {
        return viewOptions.useLargeImages || forceLargeImg || (typeof gallery !== 'undefined' && gallery.currItem.largeZoomed) ? ViewConsts.largeImage : ViewConsts.mediumImage;
    }

    function _getAdditionalDoublePageImgSizeRatio(slot0, slot1, currItem, forceLargeImg) {
        var isXml = jsonData.type === ViewConsts.xml,
            img0 = slot0 ? (isXml || slot0.tagName == 'IMG' ? slot0 : slot0.querySelector('.slide-img')) : false,
            img1 = slot1 ? (isXml || slot1.tagName == 'IMG' ? slot1 : slot1.querySelector('.slide-img')) : false,
            img0Inx = null,
            img1Inx = null,
            img0SlotInx = null,
            img1SlotInx = null,
            imgSizeKey = _getImgSizeKey(forceLargeImg),
            sizeRatio = [];

        if (img0 && slot0.getAttribute('data-page-inx')) {
            img0Inx = slot0.getAttribute('data-page-inx'),
                img0SlotInx = 0;

            if (isXml && jsonData.originalItems[img0Inx].additional_page) {
                img0 = slot0.querySelector('.slide-img');
            }

            sizeRatio[img0SlotInx] = (img0.clientHeight) / (isXml && !jsonData.originalItems[img0Inx].additional_page ? jsonData.originalItems[img0Inx].h : jsonData.originalItems[img0Inx][imgSizeKey].h);
        }

        if (img1 && slot1.getAttribute('data-page-inx')) {
            img1Inx = slot1.getAttribute('data-page-inx'),
                img1SlotInx = 1;

            if (isXml && jsonData.originalItems[img1Inx].additional_page) {
                img1 = slot1.querySelector('.slide-img');
            }

            sizeRatio[img1SlotInx] = (img1.clientHeight) / (isXml && !jsonData.originalItems[img1Inx].additional_page ? jsonData.originalItems[img1Inx].h : jsonData.originalItems[img1Inx][imgSizeKey].h);
        }

        return sizeRatio;
    }

    function _getSlots(isDoubleMode) {
        var slots = [],
            isXml = jsonData.type == ViewConsts.xml;

        if (isDoubleMode) {
            slots[0] = gallery.currItem.container.querySelector('.page.page-0' + (isXml ? '.slide-xml' : ' .slide-img'));
            slots[1] = gallery.currItem.container.querySelector('.page.page-1' + (isXml ? '.slide-xml' : ' .slide-img'));
        } else {
            slots = [gallery.currItem.container];
        }

        return slots;
    }

    function _setSize(link, item, isDoubleMode, isLargeZoomed, zoomLevel, sizeRatio) {
        var width,
            height,
            x,
            y;

        if (isDoubleMode) {
            y = (isLargeZoomed ? item.y : item.y2) * zoomLevel;
            x = (isLargeZoomed ? item.x : item.x2) * zoomLevel;

            width = item.width * zoomLevel * sizeRatio;
            height = item.height * zoomLevel * sizeRatio;
        } else {
            y = item.y * zoomLevel;
            x = item.x * zoomLevel;

            width = item.width * zoomLevel;
            height = item.height * zoomLevel;
        }

        link.style.width = width + 'px';
        link.style.height = height + 'px';

        link.style.top = y + 'px';
        link.style.left = x + 'px';
    }

    function _create(pin, page, inx, pageInx, isLargeZoomed, isDoubleMode, zoomLevel, sizeRatio) {
        var link,
            title,
            y,
            x,
            width,
            height,
            innerEl;


        link = document.createElement("div");
        link.className = 'slider-pin-zone';

        _setSize(link, pin, isDoubleMode, isLargeZoomed, zoomLevel, sizeRatio);

        // innerEl = document.createElement("div");
        // innerEl.className = "slider-pin-zone-inner"; // &::after

        if (pin.type == ViewConsts.zoneType) {

            //var pinWrap = document.createElement('div');

            //pinWrap.className = 'slider-pin'; // &::before

            switch (pin.pin_position) {
                case "1":
                    //pinWrap.className += ' abs-bottom-left';
                    link.className += ' abs-bottom-left';
                    break;
                case "2":
                    //pinWrap.className += ' abs-top-left';
                    link.className += ' abs-top-left';
                    break;
                case "3":
                    //pinWrap.className += ' abs-bottom-right';
                    link.className += ' abs-bottom-right';
                    break;
                case "4":
                    //pinWrap.className += ' abs-top-right';
                    link.className += ' abs-top-right';
                    break;
                case "5":
                    //pinWrap.className += ' abs-centered';
                    link.className += ' abs-centered';
                    break;
                default:
                    //pinWrap.className += ' abs-top-left';
                    link.className += ' abs-top-left';
                    break;
            }

            // pinWrap.style.width = (isMobile ? itemSettings.w * 0.7 : itemSettings.w) + 'px'; // Magic number 0.7. Do not remember what it is for.
            // pinWrap.style.height = (isMobile ? itemSettings.h * 0.7 : itemSettings.h) + 'px';

            //link.appendChild(pinWrap);
            //link.appendChild(innerEl);

            link.doclick = function(e) {
                var newWindow = window.open(pin.url, "_blank"),
                    pgInx = $(event.target).closest('.page').find('.slide-img').data('page-inx');

                newWindow.opener = null;

                fireEvent(window, 'view.pin.onclick', { pin: pin, pageInx: pgInx });
            };

            link.setAttribute("data-url", pin.url);
            link.setAttribute("data-real-url", pin.real_url);
        } else if (pin.type == ViewConsts.wordZoneType) {

            (isMobile) ? device = "mobile": device = "desktop";

            var param = "product_id";
            param = param.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
            var regex = new RegExp('[\\?&]' + param + '=([^&#]*)');
            var product_id = regex.exec(location.search);

            //var pinWrap = document.createElement('div');

            //pinWrap.className = 'slider-pin word-single-pin';
            link.className = 'slider-pin word-single-pin';
            //pinWrap.setAttribute("data-pin-product-id", pin.pin_product_id);
            link.setAttribute("data-pin-product-id", pin.pin_product_id);

            if (product_id != null) { 
                var product_id_real = null ? '' : decodeURIComponent(product_id[1].replace(/\+/g, ' '));
                if (product_id_real == pin.pin_product_id && highlightPin) {
                    //pinWrap.className += " word-highlighted-pin";
                    link.className += " word-highlighted-pin";
                    highlightPin = false;
                }
            }


            // pinWrap.style.width = (isMobile ? itemSettings.w * 0.7 : itemSettings.w) + 'px'; // Magic number 0.7. Do not remember what it is for.
            // pinWrap.style.height = (isMobile ? itemSettings.h * 0.7 : itemSettings.h) + 'px';
            link.style.width = (isMobile ? itemSettings.w * 0.7 : itemSettings.w) + 'px'; // Magic number 0.7. Do not remember what it is for.
            link.style.height = (isMobile ? itemSettings.h * 0.7 : itemSettings.h) + 'px';

            //link.appendChild(pinWrap);
            //link.appendChild(innerEl);



            link.doclick = function(e) {
                var wordPopup = new WordPopup(link, pin.pin_product_id, (typeof jsonData.relatedBrochuresForProductPopup !== 'undefined') ? jsonData.relatedBrochuresForProductPopup : jsonData.relatedBrochures);
                wordPopup.initWordPopup();

            };

        } else if (pin.type === ViewConsts.pinType) {}


        link.setAttribute("data-inx", inx);
        link.setAttribute("data-page-inx", pageInx);
        link.setAttribute("data-type", pin.type);


        if (pin.type == ViewConsts.zoneType || pin.type == ViewConsts.wordZoneType) {
            return link;
        } else if (pin.type == ViewConsts.pinType) {
            if (title) {
                link.appendChild(title);
            }

            page.appendChild(link);

            return link;
        }
    }

    function _removeAll() {
        var pins = document.querySelectorAll('.slider-pin-zone');
        for (var i = 0; i < pins.length; i++) {
            pins[i].parentNode.removeChild(pins[i]);
        }
    }

    function _animateShow(link, delay) {
        link.style.display = "none";

        var t = setTimeout(function() {
            link.style.display = "block";
            dom.translate(link, 0, 0, 0);

            var opacity = 1;
            if (link.className == "slider-pin slider-pin-zone") {
                opacity = 0.1;
            }

            var animate = Ani();
            animate.play("showLinkSmallSize", { scale: 0 }, { scale: 1.3 }, 333, easing.easeOutCubic, function(now) {
                dom.translate(link, 0, 0, now.scale);
            }, function() {
                animate.play("growLinkSize", { scale: 1.3, opacity: 1 }, { scale: 1, opacity: opacity }, 333, easing.easeOutCubic, function(now) {
                    dom.translate(link, 0, 0, now.scale);
                    link.style.opacity = now.opacity;
                });
            });
        }, delay);
    }

    function _load(isDoubleMode, isHtmlSlide, forceLargeImg) {

        var isXml = jsonData.type == ViewConsts.xml;
        /*if (jsonData.type == ViewConsts.xml) {
            return;
        }*/


        if ((isHtmlSlide && isDoubleMode === false) || gallery.currItem.skipPins || !gallery.currItem.container) {
            return;
        }

        _removeAll();
        var currItem = gallery.currItem,
            slots = [gallery.currItem.container],
            zonesArr = [
                [],
                []
            ], //TODO try  document.createDocumentFragment() instead
            currInx = gallery.getCurrentIndex(),
            zoomLevel = gallery.getZoomLevel(),
            isZoomed = zoomLevel != gallery.currItem.initialZoomLevel,
            isLargeZoomed = gallery.currItem.largeZoomed || viewOptions.useLargeImages,
            imgWidth = $(gallery.currItem.container).find('img').width(),
            currWidth = gallery.currItem.w,
            sizeRatio = _getImgSizeRatio(isDoubleMode, forceLargeImg),
            zoneImg = gallery.currItem,
            layer = [];

        if (isDoubleMode) {
            var slotPgInx = [],
                isRelatedBrochure = false;

            slots = _getSlots(isDoubleMode);

            // slots[0] = gallery.currItem.container.querySelector('.page.page-0' + (isXml ? '.slide-xml' : ' .slide-img'));
            // slots[1] = gallery.currItem.container.querySelector('.page.page-1' + (isXml ? '.slide-xml' : ' .slide-img'));


            if (slots[0] && !isNaN(parseInt(slots[0].getAttribute('data-page-inx')))) {
                isRelatedBrochure = slots[0].getAttribute('data-related-brochure');

                slotPgInx[0] = parseInt(slots[0].getAttribute('data-page-inx'));
                img0Pins = isRelatedBrochure ? jsonData.relatedBrochure.originalItems[slotPgInx[0]].pins : jsonData.originalItems[slotPgInx[0]].pins;
                layer[0] = { pins: img0Pins };
            }

            if (slots[1] && !isNaN(parseInt(slots[1].getAttribute('data-page-inx')))) {
                slotPgInx[1] = parseInt(slots[1].getAttribute('data-page-inx'));
                img1Pins = isRelatedBrochure ? jsonData.relatedBrochure.originalItems[slotPgInx[1]].pins : jsonData.originalItems[slotPgInx[1]].pins;
                layer[1] = { pins: img1Pins };
            }

            imgWidth = $(gallery.currItem.container).find('.double-page-slide').width();
        } else {
            currInx = gallery.currItem.inx;
            layer = layer.length > 0 ? layer : jsonData.originalItems[currInx].pins;
            layer = [{ pins: layer }];
        }

        if (isDoubleMode) {
            var addSizeRatio = _getAdditionalDoublePageImgSizeRatio(slots[0], slots[1], currItem, forceLargeImg),
                isAdditionalPage = [false, false];

            isAdditionalPage[0] = _slotHasAddPage(slots[0]); // slots[0] && jsonData.originalItems[slots[0].getAttribute('data-page-inx')].additional_page;
            isAdditionalPage[1] = _slotHasAddPage(slots[1]); // slots[1] && jsonData.originalItems[slots[1].getAttribute('data-page-inx')].additional_page;
            isAddPagePresent = isAdditionalPage[0] || isAdditionalPage[1];

            zoomLevel = [zoomLevel, zoomLevel];

            imgWidth = imgWidth = $(gallery.currItem.container).find('.double-page-slide').width();

            if (isZoomed) {
                if (isAddPagePresent || isLargeZoomed) {
                    zoomLevel[0] = addSizeRatio[0];
                    zoomLevel[1] = addSizeRatio[1];
                } else {
                    zoomLevel[0] = 1;
                    zoomLevel[1] = 1;
                }
            } else {
                zoomLevel[0] = isAddPagePresent || isLargeZoomed ? addSizeRatio[0] : zoomLevel[0];
                zoomLevel[1] = isAddPagePresent || isLargeZoomed ? addSizeRatio[1] : zoomLevel[1];
            }
        } else {
            var largeWidth = gallery.currItem.largeImage.w;
            if (!imgWidth) {
                imgWidth = parseInt(gallery.currItem.initialZoomLevel * gallery.currItem.w);
            }

            if (Math.round(imgWidth) == Math.round(largeWidth)) {
                zoomLevel = sizeRatio;
            } else {
                if (Math.round(imgWidth) > Math.round(currWidth)) {
                    zoomLevel = gallery.currItem.fitRatio;
                } else if (Math.round(imgWidth) == Math.round(currWidth)) {
                    zoomLevel = sizeRatio;
                } else {
                    zoomLevel *= sizeRatio;
                }
            }
        }
        var cnt = 0;
        for (var i = 0, lenI = layer.length; i < lenI; i++) {
            if (!slots[i]) {
                continue; //Cover slide or app pormo, no zones on this slide, so nothing to do here.
            }

            var currSlot = slots[i],
                slotInx = i;

            if (isDoubleMode) {
                currSlot = dom.getClosest(slots[i], '.page');
                currInx = slotPgInx[i];
                slotInx = currSlot.getAttribute('data-slot-inx');
            }

            if (layer[i].pins.length) {
                for (var j = 0, lenJ = layer[i].pins.length; j < lenJ; j++, cnt++) {

                    var pin = layer[i].pins[j],
                        slotZoomLevel,
                        slotSizeRatio;

                    if (isDoubleMode) {
                        slotZoomLevel = zoomLevel[slotInx];
                        slotSizeRatio = sizeRatio[slotInx];
                    } else {
                        slotZoomLevel = zoomLevel;
                        slotSizeRatio = 1;
                    }

                    if (pin.type == ViewConsts.zoneType || pin.type == ViewConsts.wordZoneType) {
                        var zone = _create(pin, currSlot, j, currInx, isLargeZoomed, isDoubleMode, slotZoomLevel, slotSizeRatio);
                        zonesArr[i].push(zone);
                    } else {
                        var link = _create(pin, currSlot, j, currInx, isLargeZoomed, isDoubleMode, slotZoomLevel, slotSizeRatio);

                        zonesArr[i].push(link);
                    }

                };

                var currInnerWrap = isDoubleMode ? currSlot.querySelector('.page-inner-wrap') : currSlot;

                for (var zI = 0, len = zonesArr[i].length; zI < len; zI++) {
                    if (isXml && isDoubleMode) {
                        currSlot.appendChild(zonesArr[i][zI]);
                    } else {
                        currInnerWrap.insertBefore(zonesArr[i][zI], currSlot.querySelector('img'));
                    }
                }
            };
        }
        if(isXml){
            // Next line makes possible blinking of zones when clicking on next and previous page
            $('.product-pin-zone').removeClass('pin-zone-animated');
            // Turn on of zones for xml products
            _animateShow3($(currItem.container).find('.product-pin-zone').get(), 0);
        }else{
            _animateShow3($(currItem.container).find('.slider-pin-zone').get(), 0);
        }
        // _animateShowZone2($(currItem.container).find('.slider-pin-zone-inner').get(), 0);

        /* new zones animation, please refactor */
        // var aDelay = 30;
        // $.each(zonesArr[0], function(cnt, link){
        //     _animateShow3(link, cnt*aDelay);
        // });

        // $.each(zonesArr[1], function(cnt, link){
        //     _animateShow3(link, cnt*aDelay);
        // });
        

        $pageZones = $('.slider-pin-zone');
        _this.$pageZones = $('.slider-pin-zone');
    }

    function _handleZoom(isDoubleMode, isHtmlSlide, forceLargeImg) {
        /*if (jsonData.type === ViewConsts.xml) {
            return;
        }*/

        var currItem = gallery.currItem;

        if ((isHtmlSlide && !isDoubleMode) || currItem.skipPins || !currItem.container) {
            return;
        }

        var zoomLevel = gallery.getZoomLevel(),
            isZoomed = zoomLevel != gallery.currItem.initialZoomLevel,
            isLargeZoomed = gallery.currItem.largeZoomed || viewOptions.useLargeImages,
            imgWidth = $(gallery.currItem.container).find('img').width(),
            currWidth = gallery.currItem.w,
            currHeight = gallery.currItem.h,
            cssObj = { 'visibility': 'visible' },
            sizeRatio = _getImgSizeRatio(isDoubleMode, forceLargeImg);

        _this.$pageZones = _this.$pageZones || $(gal.gallery.currItem.container).find('.slider-pin-zone');

        if (_this.$pageZones.length === 0) {
            return;
        }

        if (isDoubleMode) {
            var slots = _getSlots(isDoubleMode), //[gallery.currItem.container.querySelector('.page-0 .slide-img'), gallery.currItem.container.querySelector('.page-1 .slide-img')],
                addSizeRatio = _getAdditionalDoublePageImgSizeRatio(slots[0], slots[1], currItem, forceLargeImg),
                slideImgs = gallery.currItem.container.querySelectorAll('.slide-img'),
                isAdditionalPage = [false, false],
                isAddPagePresent = false;

            isAdditionalPage[0] = _slotHasAddPage(slots[0]); //slots[0] && slots[0].getAttribute('data-page-inx') && jsonData.originalItems[slots[0].getAttribute('data-page-inx')].additional_page;
            isAdditionalPage[1] = _slotHasAddPage(slots[1]); //slots[1] && slots[1].getAttribute('data-page-inx') && jsonData.originalItems[slots[1].getAttribute('data-page-inx')].additional_page;

            isAddPagePresent = isAdditionalPage[0] || isAdditionalPage[1];

            zoomLevel = [zoomLevel, zoomLevel];

            imgWidth = $(gallery.currItem.container).find('.double-page-slide').width();

            if (isZoomed) {
                if (isAddPagePresent || isLargeZoomed) {
                    zoomLevel[0] = addSizeRatio[0];
                    zoomLevel[1] = addSizeRatio[1];
                } else {
                    zoomLevel[0] = 1;
                    zoomLevel[1] = 1;
                }
            } else {
                zoomLevel[0] = isAddPagePresent || isLargeZoomed ? addSizeRatio[0] : zoomLevel[0];
                zoomLevel[1] = isAddPagePresent || isLargeZoomed ? addSizeRatio[1] : zoomLevel[1];
            }

            _this.$pageZones.css({ 'border-width': '2px' });

        } else {
            var largeWidth = gallery.currItem.largeImage.w;

            if (Math.round(imgWidth) == Math.round(largeWidth)) {
                zoomLevel = sizeRatio;
            } else {

                if (Math.round(imgWidth) > Math.round(currWidth)) {
                    zoomLevel = gallery.currItem.fitRatio;
                } else if (Math.round(imgWidth) == Math.round(currWidth)) {
                    zoomLevel = sizeRatio;
                } else {
                    zoomLevel *= sizeRatio;
                }
            }

            _this.$pageZones.css({ 'border-width': '2px' });
        }

        $('.slider-pin-zone').each(function(inx, link) {
            var pinInx = link.getAttribute("data-inx"),
                pageInx = isDoubleMode && link.parentNode.querySelector('.slide-img') ? link.parentNode.querySelector('.slide-img').getAttribute("data-page-inx") : link.getAttribute("data-page-inx"),
                slotInx = isDoubleMode && link.parentNode.querySelector('.slide-img') ? dom.getClosest(link, '.page').getAttribute("data-slot-inx") : 0,
                pin;

            pin = jsonData.originalItems[pageInx].pins[pinInx];

            _setSize(link, pin, isDoubleMode, isLargeZoomed, zoomLevel[slotInx] || zoomLevel, sizeRatio[slotInx] || sizeRatio);
        });

        _this.$pageZones.css(cssObj);
    }

    function _getImgSizeRatio(isDoubleMode, forceLargeImg) {
        var sizeRatio = 1,
            zoneImg = gallery.currItem,
            currWidth = gallery.currItem.w,
            imgSizeKey = _getImgSizeKey(forceLargeImg),
            origSlotPgInx,
            isXml = jsonData.type == ViewConsts.xml;


        if (isDoubleMode) {
            if (typeof zoneImg.container === 'undefined' || !zoneImg.container) {
                return;
            }

            var slots = _getSlots(isDoubleMode);

            sizeRatio = [];
            // slots[0] = zoneImg.container.querySelector('.page.page-0' + (isXml ? '.slide-xml' : ' .slide-img'));
            // slots[1] = zoneImg.container.querySelector('.page.page-1' + (isXml ? '.slide-xml' : ' .slide-img'));

            if (slots.length > 0 && slots[0]) {
                origSlotPgInx = parseInt(slots[0].getAttribute('data-page-inx'));
                sizeRatio[0] = isXml ? 1 : (jsonData.originalItems[origSlotPgInx][imgSizeKey].w / jsonData.originalItems[origSlotPgInx].largeImage.w);
            }

            if (slots.length == 2 && slots[1]) {
                origSlotPgInx = parseInt(slots[1].getAttribute('data-page-inx'));
                sizeRatio[1] = isXml ? 1 : (jsonData.originalItems[origSlotPgInx][imgSizeKey].w / jsonData.originalItems[origSlotPgInx].largeImage.w);
            }

        } else {
            forceLargeImg = typeof forceLargeImg !== 'undefined' ? forceLargeImg : currWidth == zoneImg.largeImage.w;
            imgSizeKey = _getImgSizeKey(forceLargeImg);
            sizeRatio = zoneImg[imgSizeKey].w / zoneImg.largeImage.w;
        }


        return sizeRatio;
    }

    function _animateShowZone2(links, delay) {
        var t = setTimeout(function() {
            for (var i = 0, len = links.length; i < len; i++) {
                var elem = links[i];
                elem.style.opacity = "0";
                elem.style.display = "block";
            }

            var animate = Ani();
            animate.play("opacity", { opacity: 0 }, { opacity: 1 }, 300, easing.easeInCubic, function(now) {
                dom.setCss(links, "opacity", now.opacity);
            }, function(endProp) {
                setTimeout(function() {
                    animate.play("growZoneSize", { opacity: 1 }, { opacity: 0.2 }, 100, easing.easeOutCubic, function(now) {
                        dom.setCss(links, "opacity", now.opacity);
                    });
                }, 1000);
            });
        }, delay);
    }

    function _animateShow3(link, delay) {
        setTimeout(function() {
            $(link).addClass('active pin-zone-animated');
        }, delay);
    }

    function _slotHasAddPage(slot) {
        if (!slot) {
            return false;
        }

        var slotPgInx = slot.getAttribute('data-page-inx');

        return slot && slotPgInx && jsonData.originalItems[slotPgInx] && jsonData.originalItems[slotPgInx].additional_page;
    }

    function _init() {
        $(document).ready(function() {
            $(document).on('mouseenter', '#view-main-wrapper .slider-pin-zone.pin-zone-animated', function(e) {
                $(this).removeClass('pin-zone-animated');
            });
        });
    }

    _this.create = _create;
    _this.removeAll = _removeAll;
    _this.animateShow = _animateShow;
    _this.load = _load;
    _this.handleZoom = _handleZoom;
    _this.init = _init;
};